import axios from 'axios';

function JwtInterceptor() {
	axios.interceptors.request.use(request => {
		const token = sessionStorage.getItem('access_token');
		request.headers.Authorization = `Bearer ${token}`;
		return request;
	});
}

export default JwtInterceptor;
